import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeApplicationStatusModal } from 'shared/redux/landingSlice';
import {
  selectApplicationStatusApplication,
  selectApplicationStatusPlace,
  selectIsApplicationStatusModalOpen,
} from 'shared/selectors/landing';

export const useApplicationStatusModal = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsApplicationStatusModalOpen);
  const application = useSelector(selectApplicationStatusApplication);
  const place = useSelector(selectApplicationStatusPlace);

  const handleModalClose = useCallback(() => {
    dispatch(closeApplicationStatusModal());
  }, [dispatch]);

  return { isModalOpen, application, place, handleModalClose };
};
